
<template>
  <el-card shadow="never" v-loading="loading" body-style="height:250px">
    <div class="flex align-items-center mb">
      <div class="hd flex align-items-center">
        <el-image :src="customization.console_imgurl ? customization.console_imgurl : logo" class="avatar index circle" fit="cover" :preview-src-list="[customization.console_imgurl ? customization.console_imgurl : '']" />
      </div>
      <div class="bd ml">
        <div class="flex align-items-center mb-sm">
          <span v-if="god.short_name" class="font-2x text-bold">您好，{{ god.short_name }}</span>
          <span v-else class="font-2x text-bold">您好，{{ god.full_name }}</span>
          <el-tag v-if="god.aiot_version" :type="god.aiot_version == 1 ? 'blue' : (god.aiot_version == 2 ? 'warning' : 'success')" class="version ml-sm">{{ god.aiot_version == 1 ? '企业版' : (god.aiot_version == 2 ? '合作版' : '免费版') }}</el-tag>
        </div>  
        <div v-if="god.certified == 0" class="text-danger">您还未完成账户实名认证</div>
        <div v-else-if="god.certified == 2" class="text-warning">账户实名认证审核中</div>
      </div>
      <div v-if="god.certified == 1" class="ft" style="width:300px">
        <div class="flex">
          <div class="bd flex align-items-center font-md" style="margin-bottom:5px">
            <span class="text-primary">
              <i class="iconfont icon-member" style="font-size: 18px;"></i>
            </span>
            <span class="ml-xs text-primary text-italic text-bold">VIP{{ level.level }}</span>
          </div>
          <div class="ft">
            {{ level.current_value }}/{{ level.next_level }}
          </div>
        </div>
        <el-progress :stroke-width="10" :show-text="false" :percentage="level.current_value / level.next_level * 100 > 100 ? 100 : level.current_value / level.next_level * 100" color="#07c160" class="progress"></el-progress>
        <div v-if="ap_quota_remain" class="flex justify-content-flex-end mt-sm">
          <div style="cursor: pointer;" @click="toAplist()">
            <span>剩余配额</span> 
            <span class="ml-sm text-success">{{ ap_quota_remain }}</span>
          </div>
        </div>
      </div>
      <div v-else-if="god.certified == 0" class="ft">
        <router-link to="/fam/certify">
          <el-button type="danger">立即认证</el-button>
        </router-link>
      </div>
    </div>
    <div class="line mb"></div>
    <el-row :gutter="20">
      <el-col :span="6">
        <div class="bg-light radius5 pt pb pl pr">
          <div class="flex justify-content-space-between mb">
            <span class="title">待确认设备</span>
            <span v-if="todo.count_equip > 0" role="button" @click="confirm" class="text-success">处理</span>
          </div>
          <div role="button" class="font-2x text-muted" :class="{ 'text-danger': todo.count_equip > 0 }" @click="confirm">{{ todo.count_equip || 0 }}</div>
        </div>
      </el-col>
      <router-link to="/home/todo">
        <el-col :span="6">
          <div class="bg-light radius5 pt pb pl pr">
            <div class="flex justify-content-space-between mb">
              <span class="title">待办任务</span>
              <span v-if="todo.count_todo > 0" role="button" class="text-success">处理</span>
            </div>
            <div role="button" class="font-2x text-muted" :class="{ 'text-danger': todo.count_todo > 0 }">{{ todo.count_todo || 0 }}</div>
          </div>
        </el-col>
      </router-link>
      <router-link to="/expense/order?pay_status=0">
        <el-col :span="6">
          <div class="bg-light radius5 pt pb pl pr">
            <div class="title mb">待支付订单</div>
            <div class="font-2x text-muted" :class="{ 'text-danger': todo.count_order_topay > 0 }">{{ todo.count_order_topay || 0 }}</div>
          </div>
        </el-col>
      </router-link>
      <router-link to="/ap/list?status=4">
        <el-col :span="6">
          <div class="bg-light radius5 pt pb pl pr">
            <div class="title mb">待续费接入点</div>
            <div class="font-2x text-muted" :class="{ 'text-danger': todo.count_ap_expired > 0 }">{{ todo.count_ap_expired || 0 }}</div>
          </div>
        </el-col>
      </router-link>

    </el-row>

    <el-dialog width="1200px" title="待确认设备" :visible.sync="dialogShow" v-loading="dialogLoading" append-to-body :modal-append-to-body="false"
       class="confirm-dialog" top="80px">

      <div class="flex align-items-center equip-count">
        <div class="pl pr-sm text-primary font-lg"><i class="iconfont icon-success"></i></div>
        <span class="pr text-primary">您有 {{ total }} 台设备待确认</span>
        <el-button type="success" size="small" @click="submitAll">全部确认</el-button>
      </div>

      <el-table class="el-table mt mb-lg padding-small" ref="confirmTable" :data="list" tooltip-effect="dark">
        <el-table-column width="60" type="index" label="#" align="center" />
        <el-table-column width="60">
          <template slot-scope="scope">
            <f-equip-avatar :equip="scope.row" />
          </template>
        </el-table-column>
        <el-table-column label="设备" :show-overflow-tooltip="true" min-width="300">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="content" label="来源" min-width="300">
          <template slot-scope="scope">
            <span>来自{{ scope.row.source_username }}</span>
          </template>
        </el-table-column>
        <el-table-column label="分享日期" min-width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.createtime | parseTime('{y}/{m}/{d}') }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="operate" label="操作" min-width="160">
          <template slot-scope="scope">
            <el-button type="text" @click="single(scope.row)">确认</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="foot">
        <f-pagination :total="total" :pindex.sync="query.pindex" :psize.sync="query.psize" @change="fetchData2" />
      </div>
    </el-dialog>
  </el-card>
</template>
  
<script>
import { mapActions } from "vuex";
import { godScheduleTodoApi } from "@/api/common/welcomeApi";
import { rmsEquipConfirmList, rmsEquipConfirmSingle, rmsEquipConfirmBatch } from "@/api/rms/rmsEquipConfirmApi";
import { getQuotaApi } from "@/api/ap/apApi";
import { getQrcodeApi } from "@/api/ei/eiApi";

export default {
  data() {
    return {
      loading: false,
      todo: {},
      dialogShow: false,
      list: [],
      total: 0,
      dialogLoading: false,
      query: {
        pindex: 1,
        psize: this.$store.state.commonStore.psize,
      },
      ap_quota_remain: 0,

      qrcodeStatus: 0,
      logo: require('@/assets/logo.png'),
    };
  },

  watch: {
    dialogShow(nval, oldval) {
      if (!nval) {
        this.fetchData();
      }
    },
  },

  computed: {
    god() {
      return this.$store.state.godStore;
    },

    customization() {
      if (this.god.customization) {
        return { ...this.god.customization, console_imgurl: this.god.customization.console_imgurl || null };
      } else {
        return {};
      }
    },

    wxapp_customization() {
      if (this.god.wxapp_customization) {
        return { ...this.god.wxapp_customization };
      } else {
        return {};
      }
    },

    level() {
      if (this.god.wxapp_customization) {
        return { ...this.god.level };
      } else {
        return {};
      }
    },

    asst_imgurl() {
      return this.$store.state.commonStore.asst_imgurl;
    },
  },

  watch: {
    god: {
      handler(val) {
        if(val.godid && !this.asst_imgurl) {
          if (this.qrcodeStatus) return;
          this.qrcodeStatus = 1; // 设置二维码加载状态为加载中
          const param = {
            scene: `godid=${val.godid}`,
            path: "pages/common/member-confirm",
            type: "asst"
          };
          getQrcodeApi(param).then((res) => {
            if (!res.errno) {
              const base64 = btoa(String.fromCharCode(...new Uint8Array(res)));
              const imgUrl = `data:image/png;base64,${base64}`;
              this.$store.commit("SET_ASST_IMGURL", imgUrl);
            } else {
              this.$message.error(res.message);
            }
            this.qrcodeStatus = 0; // 设置二维码加载状态为加载完成
          });
        }
      },
      deep: true,
    },
  },

  created() {
    this.fetchData();
    this.fetchQuota();
    this.getCustomizationInfoAction().then(() => {
    })
    console.log(this.customization, this.customization.console_imgurl)
  },

  methods: {
    ...mapActions(["setGodCustomizationAction", "getCustomizationInfoAction"]),
    fetchData() {
      this.loading = true;
      godScheduleTodoApi().then((res) => {
        this.loading = false;
        if (!res.errno) {
          this.todo = Object.assign({}, res.data);
        } else {
          this.$message.error(res.message);
        }
      });
    },

    fetchQuota() {
      getQuotaApi().then((res) => {
        if (!res.errno) {
          this.ap_quota_remain = res.data.ap_quota_remain;
        }
      });
    },

    confirm() {
      if(this.todo.count_equip <= 0 ) return;
      this.fetchData2();
      this.dialogShow = true;
    },

    fetchData2() {
      this.dialogLoading = true;
      rmsEquipConfirmList(this.query).then((res) => {
        this.dialogLoading = false;
        if (!res.errno) {
          this.list = res.data.list;
          this.total = res.data.total;
          if(this.list.length == 0) {
            this.dialogShow = false
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },

    single(row) {
      rmsEquipConfirmSingle({ equipid: row.equipid, name: row.go }).then(
        (res) => {
          if (!res.errno) {
            this.$message.success("操作成功");
            this.fetchData2();
          } else {
            this.$message.error(res.message);
          }
        }
      );
    },

    submitAll() {
      this.$confirm(
        `即将确认所有 <span class="text-success">${this.total}</span> 台设备, 是否继续？`,
        `操作提示`,
        {
          confirmButtonText: "全部确认",
          cancelButtonText: "取 消",
          dangerouslyUseHTMLString: true,
          center: true,
        }
      )
        .then(() => {
          this.dialogLoading = true;
          rmsEquipConfirmBatch().then((res) => {
            this.dialogLoading = false;
            if (!res.errno) {
              this.fetchData2();
              this.$message.success("操作成功");
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {
          // 取消
        });
    },

    toAplist() {
      this.$router.push("/ap/list");
      sessionStorage.setItem("__OPEN_QUOTA__", true);
    },
  },
};
</script>
  
<style lang="scss" scoped>
.version {
  margin-top: 5px;
  border-radius: 20px;
}

/deep/ .progress {
  .el-progress-bar__outer {
    border-radius: 25px;
  }

  .el-progress-bar__inner {
    border-radius: 25px;
  }
}

.line {
  width: 100%;
  height: 1px;
  background-color: rgba(238, 240, 245, 1);
}

.num {
  font-size: 28px;
}

.foot {
  position: absolute;
  bottom: 10px;
  right: 10px;
}

.equip-count {
  width: 100%;
  height: 56px;
  line-height: 20px;
  border-radius: 5px;
  background-color: rgba(7, 193, 96, 0.1);
}
</style>

<style lang="scss">
.el-dialog__wrapper.confirm-dialog {
  .el-dialog__body {
    padding: 0px 20px 20px 20px;
  }
}
</style>
  